/**
 * 默认租户
 */
export const DEFAULT_TENANT = 'mtbbk';

/**
 * 账号类型
 *  1: mis (员工账号，暂未支持)； 2: Passport（C端账号）； 3: EPassport(商家账号)
 */
export enum ACCOUNT_TYPE {
  /**
   * @deprecated
   * mis (员工账号，暂未支持)；
   */
  MIS = 1,
  /**
   * Passport（C端账号）；
   */
  PASSPORT = 2,
  /**
   * EPassport(商家账号)
   */
  EPASSPORT = 3,
}
